import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApiQuery } from "~/modules/filters/types";
import { Button, ButtonProps } from "~/components/ui/button";
import { faSquareTerminal } from "@fortawesome/pro-solid-svg-icons";
import { RightDrawer } from "~/components/RightDrawer";
import { ApiDocs } from "~/modules/filters/components/ApiDocs";
import {
    trackOpenApiTools,
    trackCloseApiTools,
} from "~/modules/filters/components/ApiDocs/analytics";
import { useUser } from "~/modules/user/hooks/useUser";

// // // //

export function VisualizationApiToolsButton(props: {
    query?: ApiQuery;
    apiDocsBaseUrl: string;
    disabled?: boolean;
    size?: ButtonProps["size"];
}) {
    const { query, apiDocsBaseUrl, disabled = false, size = "xs" } = props;
    const { hasApiAccess } = useUser();
    const [showModal, setShowModal] = useState(false);

    function openApiTools() {
        trackOpenApiTools({ apiDocsBaseUrl });
        setShowModal(true);
    }

    function closeApiTools() {
        trackCloseApiTools({ apiDocsBaseUrl });
        setShowModal(false);
    }

    return (
        <>
            <Button
                size={size}
                variant="outline"
                disabled={disabled}
                className="shadow-sm border-muted-foreground"
                data-testid="visualization-controls--api-tools-button"
                onClick={openApiTools}
            >
                <FontAwesomeIcon icon={faSquareTerminal} />
                Code Samples
            </Button>
            <RightDrawer
                size="xl"
                hideHeader
                open={showModal}
                onClose={closeApiTools}
            >
                <ApiDocs
                    query={query}
                    baseUrl={apiDocsBaseUrl}
                    hasApiAccess={hasApiAccess}
                    onClose={closeApiTools}
                />
            </RightDrawer>
        </>
    );
}
